import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/Fastapi.svg?component
var Fastapi_exports = /* @__PURE__ */ __exportAll({
	default: () => Fastapi_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "currentColor",
		d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m-.7 4.5h6.3L11.3 11h4.3l-9.2 6.4 2-4.4 1-2 2-4.5z"
	}, null, -1)])]);
}
var Fastapi_default = { render: render$1 };
//#endregion
export { Fastapi_exports, Fastapi_default as default, render$1 as render };

//# sourceMappingURL=Fastapi.svg.virtual.js.map